{
  "RRSP": "Rrsp",
  "TFSA": "Tfsa",
  "PERSONAL": "Efectivo",
  "RESP": "Resp",
  "RESP_SINGLE": "RESP individual",
  "RESP_FAMILY": "Resp familiar",
  "RESP_ADULT": "RESP para adultos",
  "CORPORATE_CASH": "Efectivo corporativo",
  "CORPORATE_TRUST": "Fideicomisos",
  "CORPORATE_ESTATE": "Patrimonio corporativo",
  "CORPORATE_CHARITY": "Caridad corporativa",
  "RRSP_SPOUSAL": "Rrsp conyugal",
  "LIRA": "Lira",
  "RRIF": "Rrif",
  "RIF_SPOUSAL": "Rrif conyugal",
  "LIF": "Lif",
  "PRIF": "Prif",
  "GRSP": "Grsp",
  "CASH_JOINT": "Efectivo conjunto",
  "RDSP": "Rdsp",
  "RESP_SINGLE_JOINT": "RESP Conjunta simple",
  "RESP_FAMILY_JOINT": "RESP Conjunta de familia",
  "ARTICLES_OF_INCORPORATION_OR_EQUIVALENT": "Estatutos sociales o equivalente",
  "BENEFICIARY_DESIGNATION_FORM": "Formulario de designación de beneficiarios",
  "BENEFICIARY_RRSP": "Rrsp de Beneficiario",
  "BENEFICIARY_TFSA": "Tfsa de beneficiario",
  "CLB_FOR_ADULTS": "Clb para adultos",
  "CLIENT_ACCOUNT_AGREEMENT": "Contrato de cuenta de cliente",
  "CORPORATE_ACCOUNT_AGREEMENT": "Acuerdo de cuenta corporativa",
  "CORPORATE_RESOLUTION": "Resolución corporativa",
  "DEATH_CERTIFICATE": "Certificado de defunción",
  "DECLARATION_OF_TAX_DISCLOSURE": "Declaración de divulgación fiscal",
  "DECLARATION_OF_TAX_DISCLOSURE_E": "Declaración de divulgación fiscal E",
  "DISCRETIONARY_MANAGEMENT_AGREEMENT": "Contrato de gestión discrecional",
  "EDUCATION_SAVINGS_GRANTS_APPLICATION": "Solicitud de subvenciones para ahorros educativos",
  "ELECTRONIC_DELIVERY_AGREEMENT": "Acuerdo de entrega electrónica",
  "EXTERNAL_TRANSFER_TO_NON_REGISTERED_ACCOUNTS": "Transferencia externa a cuentas no registradas",
  "EXTERNAL_TRANSFER_TO_REGISTERED_ACCOUNTS": "Transferencia externa a cuentas registradas",
  "FEE_REDIRECTION": "Redirección de tarifas",
  "FHSA": "Fhsa",
  "GOAL_INVESTMENT_POLICY_STATEMENT": "Declaración de política de inversión de objetivo",
  "INVESTMENT_POLICY_STATEMENT": "Declaración de política de inversión",
  "JOINT_CLIENT_ACCOUNT_AGREEMENT": "Acuerdo de cuenta conjunta de clientes",
  "LAST_WILL": "Última voluntad",
  "LIF_ADDENDUM": "Anexo de vida",
  "LIRA_ADDENDUM": "Anexo de Lira",
  "LOD_QESI": "Lod Qesi",
  "LRIF": "Lrif",
  "LRIF_ADDENDUM": "Anexo de Lrif",
  "LRSP": "Lrsp",
  "LRSP_ADDENDUM": "Anexo Lrsp",
  "NON_INDIVIDUAL_ENTITY_ACCOUNT_AGREEMENT": "Contrato de cuenta para entidades no individuales",
  "ONEVEST_RELATIONSHIP_DISCLOSURE_BROCHURE": "Folleto informativo sobre la relación con Onevest",
  "PAD_AGREEMENT": "Acuerdo Pad",
  "PRIF_ADDENDUM": "Anexo Prif",
  "RESP_FAMILY_PLAN": "Plan familiar Resp",
  "RESP_SINGLE_PLAN": "Plan único Resp",
  "RLIF": "Rlif",
  "RLIF_ADDENDUM": "Anexo Rlif",
  "RLSP": "Rlsp",
  "RLSP_ADDENDUM": "Anexo Rlsp",
  "SWP_AGREEMENT": "Acuerdo Swp",
  "TRUST_AGREEMENT": "Contrato de fideicomiso",
  "TRUST_DEED": "Escritura fiduciaria",
  "TRUST_PARTICIPANT_IDENTIFICATION_FORM": "Formulario de identificación del participante en el fideicomiso",
  "W8BEN": "W8Ben",
  "W9": "W9",
  "WAIVER_OF_CONFIDENTIALITY": "Renuncia a la confidencialidad",
  "W_8BEN_E": "W_8BenE",
  "W_8IMY": "W_8Imy"
}
